module.exports = __webpack_public_path__ + "img/banner6.5581ada4.jpg";